import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'dynamic-error',
  templateUrl: './dynamic-error.component.html',
  styleUrls: ['./dynamic-error.component.scss'],
})
export class DynamicErrorComponent implements OnInit {

  @Input() title: any;
  @Input() content: any;

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {}

  dismiss(flag : boolean){
    this.modalController.dismiss({flag : flag});
  }

}
